(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedFrequencyToController', MedFrequencyToController);

    MedFrequencyToController.$inject = ['$scope', '$state', 'MedFrequencyTo', 'MedFrequencyToSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile'];

    function MedFrequencyToController ($scope, $state, MedFrequencyTo, MedFrequencyToSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile ) {
        var vm = this;
        vm.title = 'Med Frequency Tos';
        vm.entityClassHumanized = 'Med Frequency To';
        vm.entityClass = 'med-frequency-to';

        vm.medFrequencyTos = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  MedFrequencyTo.query(function(result) {
                  vm.medFrequencyTos = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.medFrequencyTos, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%')*/
        .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        $compile(nRow)($scope);
        });

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            MedFrequencyTo.query(function(result) {
                vm.medFrequencyTos = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();
